<p-drawer [(visible)]="visible" position="right" styleClass="w-[30vw]! min-w-[575px]! flex flex-col" [modal]="true" appendTo="body">
    <ng-template #header>
        <div class="flex! w-full! flex-col gap-1">
            <h3 class="text-xl font-bold text-text" translate>PLACEHOLDER_DRAWER_TITLE</h3>
            <p class="text-sm text-text-muted" [translate]="dynamicOnly() ? 'DYNAMIC_PLACEHOLDER_DESC' : 'PLACEHOLDER_DESC'"></p>
        </div>
    </ng-template>

    <div class="flex! flex-col gap-8 py-4">
        @if (!dynamicOnly()) {
        <section class="flex! flex-col gap-3 p-1">
            @for (item of placeholderItems; track item.value) {
            <div
                (click)="utility.copyToClipboard(item.value)"
                class="flex! items-center justify-between p-4 border border-border rounded-md bg-surface hover:bg-surface-sunk hover:border-border-strong transition-all cursor-pointer group">
                <span class="font-medium text-text" [translate]="item.label"></span>
                <div class="flex! items-center gap-3">
                    <code class="px-3 py-1 bg-surface-sunk rounded-sm text-sm font-mono text-text-2">
                        {{ item.value }}
                    </code>
                    <i class="ph ph-copy text-text-muted group-hover:text-text"></i>
                </div>
            </div>
            }
        </section>
        }

        <!-- AUTO PROMO CODE -->
        <section [class]="dynamicOnly() ? '' : 'border-t border-border pt-6'">
            <div class="mb-4 font-semibold text-text flex items-center gap-3">
                <span translate>AUTO_PROMO_CODE</span>
            </div>

            <div class="grid! grid-cols-12 gap-5">
                <div class="col-span-4">
                    <p-floatlabel variant="on">
                        <p-inputnumber
                            class="w-full"
                            styleClass="w-full"
                            [ngModel]="autoPromoCodePlaceholderData().uses"
                            (ngModelChange)="updateAutoPromoCodeData({ uses: $event })" />
                        <label>{{ 'USES' | translate }}</label>
                    </p-floatlabel>
                </div>
                <div class="col-span-4">
                    <p-floatlabel variant="on">
                        <p-inputnumber
                            class="w-full"
                            styleClass="w-full"
                            [ngModel]="autoPromoCodePlaceholderData().validDays"
                            (ngModelChange)="updateAutoPromoCodeData({ validDays: $event })" />
                        <label>{{ 'VALID_DAYS' | translate }}</label>
                    </p-floatlabel>
                </div>
                <div class="col-span-4">
                    <p-select
                        class="w-full"
                        styleClass="w-full"
                        [ngModel]="autoPromoCodePlaceholderData().type"
                        (ngModelChange)="updateAutoPromoCodeData({ type: $event })"
                        [options]="[
                            { label: ('PERCENT' | translate), value: 'percent' },
                            { label: ('AMOUNT' | translate), value: 'amount' }
                        ]"
                        optionLabel="label"
                        optionValue="value"
                        [placeholder]="'TYPE' | translate" />
                </div>

                <div class="col-span-12">
                    <p-floatlabel variant="on">
                        @if (autoPromoCodePlaceholderData().type === 'percent') {
                        <p-inputnumber
                            class="w-full"
                            styleClass="w-full"
                            [ngModel]="autoPromoCodePlaceholderData().percent"
                            (ngModelChange)="updateAutoPromoCodeData({ percent: $event })" />
                        } @else {
                        <p-inputnumber
                            class="w-full"
                            styleClass="w-full"
                            [ngModel]="autoPromoCodePlaceholderData().amount"
                            (ngModelChange)="updateAutoPromoCodeData({ amount: $event })" />
                        }
                        <label>{{ (autoPromoCodePlaceholderData().type === 'percent' ? 'PERCENT' : 'AMOUNT') | translate }}</label>
                    </p-floatlabel>
                </div>
            </div>

            <div class="mt-6 p-5 bg-surface-sunk border border-border rounded-md flex items-start justify-between gap-5">
                <div class="flex! min-w-0 flex-1 flex-col gap-1">
                    <span class="text-[10px] uppercase tracking-widest text-text-muted font-bold">{{ 'GENERATED_CODE' | translate }}</span>
                    <span
                        class="max-w-full whitespace-normal break-all rounded-md bg-surface border border-border px-4 py-3 text-text font-mono text-sm leading-relaxed">
                        {{ autoPromoCode() || '---' }}
                    </span>
                </div>
                <button pButton class="shrink-0" (click)="copyAndClose(autoPromoCode())">
                    <i class="ph ph-copy"></i>
                    {{ 'COPY_AND_CLOSE' | translate }}
                </button>
            </div>
        </section>

        <!-- BOOKING LINK -->
        <section class="border-t border-border pt-6">
            <div class="mb-4 font-semibold text-text flex items-center gap-3">
                <span translate>BOOKING_LINK</span>
            </div>

            <div class="grid! grid-cols-12 gap-5">
                <div class="col-span-4">
                    <label class="text-sm text-text-muted">{{ 'BOOKING_FORM' | translate }}</label>
                    <div class="flex! gap-2">
                        <p-select
                            [ngModel]="bookingLinkPlaceholderData().bookingFormId"
                            (ngModelChange)="updateBookingLinkData({ bookingFormId: $event })"
                            [options]="availableBookingForms()"
                            optionLabel="name"
                            optionValue="id" />
                    </div>
                </div>
                <div class="col-span-4">
                    <div>
                        <br />
                        <div class="flex! items-center gap-2">
                            <p-toggleswitch
                                [ngModel]="bookingLinkPlaceholderData().autoCheckIn"
                                (ngModelChange)="updateBookingLinkData({ autoCheckIn: $event })" />
                            <label>{{ 'AUTO_CHECK_IN' | translate }}</label>
                        </div>
                    </div>
                </div>
                <div class="col-span-4">
                    <div>
                        <br />
                        <div class="flex! items-center gap-2">
                            <p-toggleswitch
                                [ngModel]="bookingLinkPlaceholderData().promoCodeEnabled"
                                (ngModelChange)="updateBookingLinkData({ promoCodeEnabled: $event })" />
                            <label>{{ 'ADD_PROMO_CODE' | translate }}</label>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            @if (bookingLinkPlaceholderData().promoCodeEnabled) {
            <div class="grid! grid-cols-12 gap-5">
                <div class="col-span-4">
                    <p-floatlabel variant="on">
                        <p-inputnumber
                            class="w-full"
                            styleClass="w-full"
                            [ngModel]="bookingLinkPlaceholderData().promoCodeUses"
                            (ngModelChange)="updateBookingLinkData({ promoCodeUses: $event })" />
                        <label>{{ 'USES' | translate }}</label>
                    </p-floatlabel>
                </div>
                <div class="col-span-4">
                    <p-floatlabel variant="on">
                        <p-inputnumber
                            class="w-full"
                            styleClass="w-full"
                            [ngModel]="bookingLinkPlaceholderData().promoCodeValidHours"
                            (ngModelChange)="updateBookingLinkData({ promoCodeValidHours: $event })" />
                        <label>{{ 'VALID_HOURS' | translate }}</label>
                    </p-floatlabel>
                </div>
                <div class="col-span-4">
                    <p-floatlabel variant="on">
                        <p-inputnumber
                            class="w-full"
                            styleClass="w-full"
                            [ngModel]="bookingLinkPlaceholderData().promoCodeValidMinutes"
                            (ngModelChange)="updateBookingLinkData({ promoCodeValidMinutes: $event })" />
                        <label>{{ 'VALID_MINUTES' | translate }}</label>
                    </p-floatlabel>
                </div>
                <div class="col-span-4">
                    <p-select
                        class="w-full"
                        styleClass="w-full"
                        [ngModel]="bookingLinkPlaceholderData().promoCodeType"
                        (ngModelChange)="updateBookingLinkData({ promoCodeType: $event })"
                        [options]="[
                                { label: ('PERCENT' | translate), value: 'percent' },
                                { label: ('AMOUNT' | translate), value: 'amount' }
                            ]"
                        optionLabel="label"
                        optionValue="value"
                        [placeholder]="'TYPE' | translate" />
                </div>

                <div class="col-span-12">
                    <p-floatlabel variant="on">
                        @if (bookingLinkPlaceholderData().promoCodeType === 'percent') {
                        <p-inputnumber
                            class="w-full"
                            styleClass="w-full"
                            [ngModel]="bookingLinkPlaceholderData().promoCodePercent"
                            (ngModelChange)="updateBookingLinkData({ promoCodePercent: $event })" />
                        } @else {
                        <p-inputnumber
                            class="w-full"
                            styleClass="w-full"
                            [ngModel]="bookingLinkPlaceholderData().promoCodeAmount"
                            (ngModelChange)="updateBookingLinkData({ promoCodeAmount: $event })" />
                        }
                        <label>{{ (bookingLinkPlaceholderData().promoCodeType === 'percent' ? 'PERCENT' : 'AMOUNT') | translate }}</label>
                    </p-floatlabel>
                </div>
            </div>
            }

            <div class="mt-6 p-5 bg-surface-sunk border border-border rounded-md flex items-start justify-between gap-5">
                <div class="flex! min-w-0 flex-1 flex-col gap-1">
                    <span class="text-[10px] uppercase tracking-widest text-text-muted font-bold">{{ 'GENERATED_CODE' | translate }}</span>
                    <span
                        class="max-w-full whitespace-normal break-all rounded-md bg-surface border border-border px-4 py-3 text-text font-mono text-sm leading-relaxed">
                        {{ bookingLink() || '---' }}
                    </span>
                </div>
                <button pButton class="shrink-0" (click)="copyAndClose(bookingLink())">
                    <i class="ph ph-copy"></i>
                    {{ 'COPY_AND_CLOSE' | translate }}
                </button>
            </div>
        </section>
    </div>
</p-drawer>
